import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MessageCircle, MapPin } from "lucide-react";
import api from "../lib/api";
import { BrandLogo } from "./BrandLogo";

export const Footer = () => {
  const [settings, setSettings] = useState(null);

  useEffect(() => {
    api.get("/settings/public").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const name = settings?.business_name || "DreamCots";

  return (
    <footer className="hidden md:block border-t-2 border-[#171B33] bg-white mt-16">
      <div className="max-w-7xl mx-auto px-4 sm:px-8 py-12 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <span className="flex items-center gap-2.5">
            <BrandLogo settings={settings} testid="footer-brand" />
          </span>
          <p className="text-sm text-slate-500 mt-4 leading-relaxed">{settings?.tagline || "Find the best coaching institutes & schools in your city."}</p>
        </div>
        <div>
          <p className="nb-label mb-4">Quick Links</p>
          <ul className="space-y-2.5 text-sm font-semibold">
            <li><Link to="/about" data-testid="footer-about-link" className="hover:text-lime-600 transition-colors duration-150">About Us</Link></li>
            <li><Link to="/contact" data-testid="footer-contact-link" className="hover:text-lime-600 transition-colors duration-150">Contact Us</Link></li>
            <li><Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-lime-600">Privacy Policy</Link></li>
            <li><Link to="/terms" data-testid="footer-terms-link" className="hover:text-lime-600 transition-colors duration-150">Terms and Conditions</Link></li>
            <li><Link to="/packages" data-testid="footer-packages-link" className="hover:text-lime-600 transition-colors duration-150">Packages</Link></li>
            <li><Link to="/rankings" data-testid="footer-rankings-link" className="hover:text-lime-600 transition-colors duration-150">Rankings</Link></li>
          </ul>
        </div>
        <div>
          <p className="nb-label mb-4">Contact</p>
          <ul className="space-y-2.5 text-sm font-semibold">
            {settings?.phone && <li><a href={`tel:${settings.phone}`} data-testid="footer-phone" className="flex items-center gap-2 hover:text-lime-600 transition-colors duration-150"><Phone className="w-4 h-4" /> {settings.phone}</a></li>}
            {settings?.whatsapp && <li><a href={`https://wa.me/${settings.whatsapp.replace(/\D/g, "")}`} target="_blank" rel="noreferrer" data-testid="footer-whatsapp" className="flex items-center gap-2 text-green-600 hover:text-green-700 transition-colors duration-150"><MessageCircle className="w-4 h-4" /> WhatsApp</a></li>}
            {settings?.email && <li><a href={`mailto:${settings.email}`} data-testid="footer-email" className="flex items-center gap-2 hover:text-lime-600 transition-colors duration-150"><Mail className="w-4 h-4" /> {settings.email}</a></li>}
            {settings?.address && <li className="flex items-center gap-2 text-slate-500"><MapPin className="w-4 h-4" /> {settings.address}</li>}
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200 py-5 text-center text-sm text-slate-500">
        © 2026 {name}. Made with love{settings?.address ? ` in ${settings.address}` : ""}.
      </div>
    </footer>
  );
};

export default Footer;
